import React from 'react';

const HSNSummary = ({ hsnSummary, isBillOfSupply, isInterState, variant }) => {
    if (isBillOfSupply || hsnSummary.length === 0) return null;

    const isClassic = variant === 'classic';

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 2
        }).format(amount || 0);
    };

    return (
        <div className={`overflow-hidden mt-6 w-full ${isClassic
            ? 'border-2 border-slate-800 bg-white'
            : 'bg-white rounded-xl shadow-sm border border-slate-200 mx-auto max-w-5xl'
            }`}>
            <div className={`p-4 border-b ${isClassic ? 'border-slate-800 bg-slate-50' : 'border-slate-200 bg-white'}`}>
                <h3 className={`font-bold uppercase tracking-tight ${isClassic ? 'text-lg text-slate-900 font-serif' : 'text-lg text-slate-800'}`}>HSN Summary</h3>
            </div>
            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className={`${isClassic ? 'bg-slate-100' : 'bg-slate-50'} border-b ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>
                            <th className={`py-2 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider w-24 border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>HSN</th>
                            <th className={`py-2 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>Taxable Amount</th>
                            {!isBillOfSupply && (
                                <>
                                    {isInterState ? (
                                        <>
                                            <th className={`py-2 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-right w-24 border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>IGST Rate</th>
                                            <th className={`py-2 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>IGST Amount</th>
                                        </>
                                    ) : (
                                        <>
                                            <th className={`py-2 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-right w-24 border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>CGST Rate</th>
                                            <th className={`py-2 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>CGST Amount</th>
                                            <th className={`py-1 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-right w-24 border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>SGST Rate</th>
                                            <th className={`py-2 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>SGST Amount</th>
                                        </>
                                    )}
                                    <th className="py-2 px-3 text-xs font-bold text-slate-500 uppercase tracking-wider text-right w-32">Total Tax</th>
                                </>
                            )}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-200">
                        {hsnSummary.map((item, index) => {
                            return (
                                <tr key={index} className={`${isClassic ? '' : 'hover:bg-slate-50'} transition-colors ${isClassic ? '' : 'border-b border-slate-200'}`}>
                                    <td className={`px-3 py-1 text-sm font-medium text-slate-700 border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>{item.hsnCode || 'N/A'}</td>
                                    <td className={`px-3 py-1 text-sm text-slate-600 text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>{formatCurrency(item.taxableAmount)}</td>
                                    {!isBillOfSupply && (
                                        <>
                                            {isInterState ? (
                                                <>
                                                    <td className={`px-3 py-1 text-sm text-slate-600 text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>{item.gstRate}%</td>
                                                    <td className={`px-3 py-1 text-sm text-slate-600 text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>{formatCurrency(item.igst)}</td>
                                                </>
                                            ) : (
                                                <>
                                                    <td className={`px-3 py-1 text-sm text-slate-600 text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>{item.gstRate / 2}%</td>
                                                    <td className={`px-3 py-1 text-sm text-slate-600 text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>{formatCurrency(item.cgst)}</td>
                                                    <td className={`px-3 py-1 text-sm text-slate-600 text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>{item.gstRate / 2}%</td>
                                                    <td className={`px-3 py-1 text-sm text-slate-600 text-right border-r ${isClassic ? 'border-slate-800' : 'border-slate-200'}`}>{formatCurrency(item.sgst)}</td>
                                                </>
                                            )}
                                            <td className="px-3 py-1 text-sm font-bold text-slate-700 text-right">{formatCurrency(item.totalTax)}</td>
                                        </>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default HSNSummary;
